module.exports = __webpack_public_path__ + "img/icon_ai_play_playing.77392df4.gif";